const state = {
  categories: [],
  core_products: [],
  design_groups: []
};

const getters = {
  categories(state) {
    return state.categories || [];
  },
  printableCategories(state) {
    return state.categories.filter((x) => x.startQuantity !== null) || [];
  },
  non_parent_categories(state, getters) {
    return getters.categories.filter((x) => !x.parentId);
  },
  all_core_products(state) {
    return state.core_products || [];
  },
  core_products(state, getters) {
    return (categoryId) => {
      return getters.all_core_products.filter((x) => x.categoryId === categoryId);
    };
  },
  core_product(state, getters) {
    return (id) => {
      return getters.all_core_products.filter((x) => x.id === id)[0];
    };
  },
  core_products_printable(state, getters) {
    return (categoryId) => {
      return getters.all_core_products.filter((x) => x.categoryId === categoryId && x.printable);
    };
  },
  design_groups(state) {
    return state.design_groups || [];
  }
};

const actions = {
  getCategories({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      if (!rootGetters['user/master_account'].enableMcsTemplates) resolve();
      this._vm.$api
        .get('data/getAppData')
        .then((response) => {
          commit('SET_CATEGORIES', response.data.categories);
          commit('SET_CORE_PRODUCTS', response.data.coreProducts);
          commit('SET_DESIGN_GROUPS', response.data.designGroups);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

const mutations = {
  SET_CATEGORIES(state, payload) {
    state.categories = payload;
  },
  SET_CORE_PRODUCTS(state, payload) {
    state.core_products = payload;
  },
  SET_DESIGN_GROUPS(state, payload) {
    state.design_groups = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
